import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import camelCase from 'lodash-es/camelCase';
import { Suspense, lazy } from 'react';

import normalizeCardTheme from '../../lib/normalizeCardTheme';

import CardTitle from '../typography/CardTitle';
import HorizontalCard from './HorizontalCard';

import styles from '../../styles/cards/location-type-horizontal-card.module.css';

const MapIcon = lazy(() => import('../icons/maps/MapIcon'));
interface LocationTypeHorizontalCardProps extends Partial<LocationType> {
    onClick?: ((slug: string) => void) | null;
    theme?: CardTheme | LegacyCardTheme | null;
    size?: CardSize | null;
    icon?: string | null;
    active?: boolean;
    placeholder?: boolean;
    withBorder?: boolean;
    className?: string | null;
}
function LocationTypeHorizontalCard({
    slug = null,
    onClick = null,
    label = null,
    theme: providedTheme = null,
    size = null,
    icon = null,
    active = false,
    placeholder = false,
    withBorder = false,
    className = null,
}: LocationTypeHorizontalCardProps) {
    const theme = normalizeCardTheme(providedTheme);
    const url = useUrlGenerator();
    return (
        <HorizontalCard
            theme={theme || 'none'}
            href={
                slug !== null && onClick === null
                    ? url('map.locationType', {
                          locationType: slug,
                      })
                    : null
            }
            onClick={() => {
                if (onClick !== null) {
                    onClick(slug);
                }
            }}
            thumbnail={
                <Suspense fallback={<span className={styles.icon} />}>
                    <MapIcon icon={icon || slug || 'autres-sports'} className={styles.icon} />
                </Suspense>
            }
            className={classNames([
                styles.container,
                styles[camelCase(size)],
                {
                    [styles.withBorder]: withBorder,
                    [styles.active]: active,
                },
                className,
            ])}
            innerClassName={styles.inner}
            thumbnailClassName={styles.thumbnailContainer}
        >
            <CardTitle tag="span" className={styles.title} placeholder={placeholder}>
                {label}
            </CardTitle>
        </HorizontalCard>
    );
}
export default LocationTypeHorizontalCard;
